import React from "react";
import "./HowItWorks.scss";
import BgRing from "../../assests/images/banner-bg-ring.svg";
import TakeQuiz from "../../assests/images/quiz.svg";
import SearchDocs from "../../assests/images/search-docs.png";
import ClaimCompensation from "../../assests/images/claim-compensation.png";
const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="container1286">
        <div>
          <div className="how-it-works__details">
            <h1>
              Here is How <strong>it works</strong>
            </h1>
            <p>
              Within a few minutes you will find out if you are eligible for a
              FREE claim assessment.
            </p>
          </div>
          <figure className="how-it-works__ring">
            <img src={BgRing} alt="" srcSet="" />
          </figure>
        </div>

        <div className="how-it-works__steps">
          <div className="how-it-works__steps-one">
            <div className="how-it-works__steps-one-round">
              <figure>
                <img src={TakeQuiz} alt="" />
              </figure>
              <div className="digit">1</div>
            </div>
            <div className="how-it-works__steps-one-details">
              <h2>Take a quiz</h2>
              <p>
                Take a quick quiz to evaluate if you qualify for a free claim
                assessment.
              </p>
            </div>
          </div>
          <div className="how-it-works__steps-one">
            <div className="how-it-works__steps-one-round">
              <figure>
                <img src={SearchDocs} alt="" />
              </figure>
              <div className="digit">2</div>
            </div>
            <div className="how-it-works__steps-one-details">
              <h2>We’ll assess the details</h2>
              <p>
                Our friendly team will give you a call within minutes to discuss
                further details with you.
              </p>
            </div>
          </div>
          <div className="how-it-works__steps-one">
            <div className="how-it-works__steps-one-round">
              <figure>
                <img src={ClaimCompensation} alt="" />
              </figure>
              <div className="digit">3</div>
            </div>
            <div className="how-it-works__steps-one-details">
              <h2>
                Commence your <br /> claim procedure
              </h2>
              <p>
                We will then match you with the solicitors we work with to start
                your case.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
